import { render, staticRenderFns } from "./SideBarLayout.vue?vue&type=template&id=bc70246c&"
import script from "./SideBarLayout.vue?vue&type=script&lang=js&"
export * from "./SideBarLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports